import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-warning-bar',
  templateUrl: './warning-bar.component.html',
  styleUrls: ['./warning-bar.component.scss'],
})
export class WarningBarComponent {
  @Input() title = 'Atenção';
  @Input() message = '';
  @Input() items: string[] = [];
}
